import { useContext, useState } from 'react';
import Button from '../../components/Button';
import { Col, Container, Row, Form, FormControl, FormGroup } from 'react-bootstrap';
import GenericCard from '../../components/GenericCards';
import Label from '../../components/Label';
import { useNavigate } from 'react-router-dom';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import {
    addOrRemoveDaysToGivenDate,
    addOrRemoveMonthsToGivenDate,
    DateFormats,
    formatDate,
    formatPrice,
  } from '../../utils/utils';
import {
PAY_NOW_ROUTE,
} from '../../routes/types';
import useMobile from '../../hooks/useMobileHook';
import useModal from '../../hooks/useModal';
import { ModalManagementStore } from '../../providers/modal-manager';
import { mapProfileIds } from '../../services/profiles';
import PaymentHistoryModal from '../widgets/PaymentInformation/PaymentHistoryModal';

const recentPayments: any[] = [
    {
      statement: formatDate(
        addOrRemoveMonthsToGivenDate(new Date(), -1),
        DateFormats.M_YEAR
      ),
      coverageDates: `${formatDate(
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        DateFormats.US
      )} - ${formatDate(
        new Date(new Date().getFullYear(), new Date().getMonth(), 0),
        DateFormats.US
      )}`,
      amoutDue: formatPrice(332, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      paymentReceived: formatPrice(332, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      method: 'Credit Card',
      dateConfig: {
        year: new Date().getFullYear(),
        month: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 1,
          1
        ).getMonth(),
      },
    },
  
    {
      statement: formatDate(
        addOrRemoveMonthsToGivenDate(new Date(), -2),
        DateFormats.M_YEAR
      ),
      coverageDates: `${formatDate(
        new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
        DateFormats.US
      )} - ${formatDate(
        new Date(new Date().getFullYear(), new Date().getMonth() - 1, 0),
        DateFormats.US
      )}`,
      amoutDue: formatPrice(332, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      paymentReceived: formatPrice(332, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      method: 'Credit Card',
      dateConfig: {
        year: new Date().getFullYear(),
        month: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 1,
          1
        ).getMonth(),
      },
    },
  
    {
      statement: formatDate(
        addOrRemoveMonthsToGivenDate(new Date(), -3),
        DateFormats.M_YEAR
      ),
      coverageDates: `${formatDate(
        new Date(new Date().getFullYear(), new Date().getMonth() - 2, 1),
        DateFormats.US
      )} - ${formatDate(
        new Date(new Date().getFullYear(), new Date().getMonth() - 2, 0),
        DateFormats.US
      )}`,
      amoutDue: formatPrice(332, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      paymentReceived: formatPrice(332, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      method: 'Credit Card',
      dateConfig: {
        year: new Date().getFullYear(),
        month: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 2,
          1
        ).getMonth(),
      },
    },
];


const paymentHistory: any[] = [
  {
    statement: 'Nov 2022',
    coverageDates: `${formatDate(
      new Date(new Date().getFullYear(), 11, 1),
      DateFormats.US
    )} - ${formatDate(
      new Date(new Date().getFullYear(), 11, 31),
      DateFormats.US
    )}`,
    amoutDue: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    paymentReceived: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    method: 'Credit Card',
    dateConfig: {
      year: new Date().getFullYear(),
      month: new Date(new Date().getFullYear(), 9, 1).getMonth(),
    },
  },

  {
    statement: 'Oct 2022',
    coverageDates: `${formatDate(
      new Date(new Date().getFullYear(), 10, 1),
      DateFormats.US
    )} - ${formatDate(
      new Date(new Date().getFullYear(), 10, 30),
      DateFormats.US
    )}`,
    amoutDue: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    paymentReceived: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    method: 'Credit Card',
    dateConfig: {
      year: new Date().getFullYear(),
      month: new Date(new Date().getFullYear(), 7, 1).getMonth(),
    },
  },

  {
    statement: 'Sep 2022',
    coverageDates: `${formatDate(
      new Date(new Date().getFullYear(), 9, 1),
      DateFormats.US
    )} - ${formatDate(
      new Date(new Date().getFullYear(), 9, 31),
      DateFormats.US
    )}`,
    amoutDue: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    paymentReceived: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    method: 'Bank Account',
    dateConfig: {
      year: new Date().getFullYear(),
      month: new Date(new Date().getFullYear(), 8, 1).getMonth(),
    },
  },

  {
    statement: 'Aug 2022',
    coverageDates: `${formatDate(
      new Date(new Date().getFullYear(), 8, 1),
      DateFormats.US
    )} - ${formatDate(
      new Date(new Date().getFullYear(), 8, 30),
      DateFormats.US
    )}`,
    amoutDue: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    paymentReceived: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    method: 'Credit Card',
    dateConfig: {
      year: new Date().getFullYear(),
      month: new Date(new Date().getFullYear(), 7, 1).getMonth(),
    },
  },
  {
    statement: 'Jul 2022',
    coverageDates: `${formatDate(
      new Date(new Date().getFullYear(), 7, 1),
      DateFormats.US
    )} - ${formatDate(
      new Date(new Date().getFullYear(), 7, 31),
      DateFormats.US
    )}`,
    amoutDue: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    paymentReceived: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    method: 'Credit Card',
    dateConfig: {
      year: new Date().getFullYear(),
      month: new Date(new Date().getFullYear(), 7, 1).getMonth(),
    },
  },
  {
    statement: 'Jun 2022',
    coverageDates: `${formatDate(
      new Date(new Date().getFullYear(), 6, 1),
      DateFormats.US
    )} - ${formatDate(
      new Date(new Date().getFullYear(), 6, 31),
      DateFormats.US
    )}`,
    amoutDue: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    paymentReceived: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    method: 'Bank Account',
    dateConfig: {
      year: new Date().getFullYear(),
      month: new Date(new Date().getFullYear(), 7, 1).getMonth(),
    },
  },
  {
    statement: 'May 2022',
    coverageDates: `${formatDate(
      new Date(new Date().getFullYear(), 5, 1),
      DateFormats.US
    )} - ${formatDate(
      new Date(new Date().getFullYear(), 5, 30),
      DateFormats.US
    )}`,
    amoutDue: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    paymentReceived: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    method: 'Credit Card',
    dateConfig: {
      year: new Date().getFullYear(),
      month: new Date(new Date().getFullYear(), 7, 1).getMonth(),
    },
  },
  {
    statement: 'Apr 2022',
    coverageDates: `${formatDate(
      new Date(new Date().getFullYear(), 4, 1),
      DateFormats.US
    )} - ${formatDate(
      new Date(new Date().getFullYear(), 4, 31),
      DateFormats.US
    )}`,
    amoutDue: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    paymentReceived: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    method: 'Credit Card',
    dateConfig: {
      year: new Date().getFullYear(),
      month: new Date(new Date().getFullYear(), 7, 1).getMonth(),
    },
  },
  {
    statement: 'Mar 2022',
    coverageDates: `${formatDate(
      new Date(new Date().getFullYear(), 3, 1),
      DateFormats.US
    )} - ${formatDate(
      new Date(new Date().getFullYear(), 3, 30),
      DateFormats.US
    )}`,
    amoutDue: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    paymentReceived: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    method: 'Bank Account',
    dateConfig: {
      year: new Date().getFullYear(),
      month: new Date(new Date().getFullYear(), 7, 1).getMonth(),
    },
  },
  {
    statement: 'Feb 2022',
    coverageDates: `${formatDate(
      new Date(new Date().getFullYear(), 2, 1),
      DateFormats.US
    )} - ${formatDate(
      new Date(new Date().getFullYear(), 2, 31),
      DateFormats.US
    )}`,
    amoutDue: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    paymentReceived: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    method: 'Credit Card',
    dateConfig: {
      year: new Date().getFullYear(),
      month: new Date(new Date().getFullYear(), 7, 1).getMonth(),
    },
  },
  {
    statement: 'Jan 2022',
    coverageDates: `${formatDate(
      new Date(new Date().getFullYear(), 1, 1),
      DateFormats.US
    )} - ${formatDate(
      new Date(new Date().getFullYear(), 1, 28),
      DateFormats.US
    )}`,
    amoutDue: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    paymentReceived: formatPrice(332, 'en-US', {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 2,
    }),
    method: 'Credit Card',
    dateConfig: {
      year: new Date().getFullYear(),
      month: new Date(new Date().getFullYear(), 7, 1).getMonth(),
    },
  },
];

const PendingPay = () => {
  const navigate = useNavigate();
  const isMobile = useMobile();
  const [
    showPaymentHistoryModal,
    handleShowPaymentHistoryModal,
    handleClosePaymentHistoryModal,
  ] = useModal();
  const [showModal, handleShowModal, handleCloseModal] = useModal();  
  const { openModal } = useContext(ModalManagementStore);

  return (
    <Container className="cnd-custom-container-large mb-12 px-lg-9 px-xl-0">
      <Row className={'mt-7 mt-lg-13'}>
        <Col
          sm={12}
          lg={12}
          className={
            'd-flex justify-content-between align-items-center pt-lg-8'
          }
        >
          <h4 className={'h4 fw-light mb-0'}>{'Payment Information'}</h4>
        </Col>
      </Row>
      <Row className={'mt-10'}>
        <Col sm={12} lg={12}>
          <GenericCard variant="white" style={{ zIndex: '1000' }}>
            <Row className={'w-100 fw-light m-0 justify-content-between'}>
              <Col className={'col-6 p-7 p-lg-0'}>
                <div
                  className={'text-dark-gray text-sm-12-lg-14 text-lg-start'}
                >
                  <Label
                    className={
                      'text-dark-gray text-sm-12-lg-14 text-lg-start p-0'
                    }
                    rightIcon={light('circle-exclamation')}
                  >
                    {'Total Due'}
                  </Label>
                </div>
                <div className={'text-dark-gray fs-5 my-4 text-lg-start'}>
                  {formatPrice(332.0)}
                </div>
              </Col>
              <Col
                className={
                  'col-6 p-7 p-lg-0 d-flex align-items-center justify-content-end'
                }
              >
                <Button
                  variant="primary"
                  onClick={() => navigate(PAY_NOW_ROUTE)}
                >
                  Pay Now
                </Button>
              </Col>
            </Row>
            <Row
              className={`m-0 mt-7 pt-7 d-lg-flex flex-lg-row justify-content-between ${
                !isMobile ? 'border-top' : ''
              } `}
            >
              <Row
                className={`m-0 ${
                  isMobile ? 'border-bottom' : ''
                } px-0 py-3 py-lg-0 col-lg-3 flex-lg-column`}
              >
                <Col className="p-0">
                  <span className="fw-light text-sub1 lh-xxs text-ligther-grey">
                    Current Balance
                  </span>
                </Col>
                <Col className="p-0 text-end text-lg-start">
                  <span className="fw-normal text-sub1 lh-xxs">
                    {formatPrice(332.0)}
                  </span>
                </Col>
              </Row>
              <Row
                className={`m-0 ${
                  isMobile ? 'border-bottom' : ''
                } px-0 py-3 py-lg-0 col-lg-3 flex-lg-column`}
              >
                <Col className="p-0">
                  <span className="fw-light text-sub1 lh-xxs text-ligther-grey">
                    Past Due
                  </span>
                </Col>
                <Col className="p-0 text-end text-lg-start">
                  <span className="fw-normal text-sub1 lh-xxs">
                    {formatPrice(0.0)}
                  </span>
                </Col>
              </Row>
              <Row
                className={`m-0 ${
                  isMobile ? 'border-bottom' : ''
                } px-0 py-3 py-lg-0 col-lg-3 flex-lg-column`}
              >
                <Col className="p-0">
                  <span className="fw-light text-sub1 lh-xxs text-ligther-grey">
                    Due date
                  </span>
                </Col>
                <Col className="p-0 text-end text-lg-start">
                  <span className="fw-normal text-sub1 lh-xxs">
                    {formatDate(
                      addOrRemoveMonthsToGivenDate(
                        new Date(
                          new Date().getFullYear(),
                          new Date().getMonth(),
                          1
                        ),
                        1
                      ),
                      DateFormats.SHORT_MONTH_DAY_YEAR
                    )}
                  </span>
                </Col>
              </Row>
              <Row className="m-0 px-0 py-3 py-lg-0 col-lg-2 flex-lg-column">
                <Col className="p-0 text-lg-end">
                  <span className="fw-light text-sub1 lh-xxs text-ligther-grey">
                    Statement
                  </span>
                </Col>
                <Col className="p-0 text-end text-lg-end">
                  <span className="fw-normal text-sub1 lh-xxs text-primary">
                    {formatDate(new Date(), DateFormats.M_YEAR)}
                  </span>
                </Col>
              </Row>
            </Row>
          </GenericCard>

          <GenericCard
                    className={'d-none d-lg-block'}
                    style={{ marginTop: '-15px' }}
                  >
                    <Row>
                      <Col>
                        <h2 className={'text-sm-20-lg-24 fw-light'}>
                          Recent Payments
                        </h2>
                      </Col>
                      <Col className={'text-end'}>
                        <Button
                          variant={'primary-outline'}
                          onClick={handleShowPaymentHistoryModal}
                        >
                          Payment History
                        </Button>
                        <PaymentHistoryModal
                          showModal={showPaymentHistoryModal}
                          handleClose={handleClosePaymentHistoryModal}
                          paymentHistoryData={paymentHistory}
                        />
                      </Col>
                    </Row>

                    <Row className={'mt-10 py-3 border-bottom-dark-gray'}>
                      <Col className={'col-3'}>
                        <span className={'text-fs-6 fw-normal'}>
                          Statement/Receipt
                        </span>
                      </Col>
                      <Col className={'col-3'}>
                        <span className={'text-fs-6 fw-normal'}>
                          Coverage Dates
                        </span>
                      </Col>
                      <Col className={'col-2 text-end'}>
                        <span className={'text-fs-6 fw-normal'}>
                          Amount Due
                        </span>
                      </Col>
                      <Col className={'col-2 px-0 text-end'}>
                        <span className={'text-fs-6 fw-normal'}>
                          Payment Received
                        </span>
                      </Col>
                      <Col className={'col-2 text-end'}>
                        <span className={'text-fs-6 fw-normal'}>Method</span>
                      </Col>
                    </Row>

                    {recentPayments.map((recentPayment, idx) => (
                      <Row
                        className={`py-3 ${
                          idx !== recentPayments.length - 1
                            ? 'border-bottom-light-gray-lg'
                            : ''
                        }`}
                      >
                        <Col className={'col-3'}>
                          <span
                            className="text-fs-6 fw-light text-blue pointer-hover"
                            onClick={() =>
                              openModal('payment-information-statement', {
                                dateConfig: recentPayment.dateConfig,
                              })
                            }
                          >
                            {recentPayment.statement}
                          </span>
                        </Col>
                        <Col className={'col-3'}>
                          <span className={'text-fs-6 fw-light'}>
                            {recentPayment.coverageDates}
                          </span>
                        </Col>
                        <Col className={'col-2 text-end'}>
                          <span className={'text-fs-6 fw-light'}>
                            {recentPayment.amoutDue}
                          </span>
                        </Col>
                        <Col className={'col-2 px-0 text-end'}>
                          <span className={'text-fs-6 fw-light'}>
                            {recentPayment.paymentReceived}
                          </span>
                        </Col>
                        <Col className={'col-2 text-end'}>
                          <span className={'text-fs-6 fw-light'}>
                            {recentPayment.method}
                          </span>
                        </Col>
                      </Row>
                    ))}
                  </GenericCard>
        </Col>
      </Row>
    </Container>
  );
};

export default PendingPay